window.ttx = window.ttx || {};
ttx.load = {}
ttx.load = {
    _isLoading: false,
    getLoad() {
        return this._isLoading;
    },
    setLoad(load, callBack) {
        // 如果是重复加载，直接阻止
        if (this._isLoading === true && load === true) {
            return;
        }

        if (!load) {
            this._isLoading = false;
            callBack && callBack(load);
            this._setLoadByWin();
            return;
        }

        this._isLoading = true;
        this._setLoadByWin();

        this.promise = new Promise((resolve, reject) => {
            callBack && callBack(resolve, reject);
        })
            .then(() => {
            })
            .catch(() => {
            })
            .finally(() => {
                this._isLoading = false;
                this._setLoadByWin();
            });
    },
    _setLoadByWin(){        
        if(window.ttx.load.setLoadByWin){
            window.ttx.load.setLoadByWin(this._isLoading);
        }
    }
};


